module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Preview":"Preview","Beauty filters":"Beauty filters"},"zh":{"Preview":"视频预览","Beauty filters":"开启美颜"}}')
  delete Component.options._Ctor
}
